// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/bg2023.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/images/menu2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Saira:wght@100;200;300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fontsstorage.blob.core.windows.net/html/css/quantum.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fontsstorage.blob.core.windows.net/html/css/georama.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #eee;
  overflow-y: scroll;
  font-family: "Georama-Regular" !important;
  background-attachment: fixed;
  background-position: center;
  background-size: cover !important;
}

@media screen and (max-width: 600px) {
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-color: #eee;
    background-repeat: no-repeat;
  }
}

@media screen and (min-width: 600px) {
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-color: #eee;
    background-repeat: no-repeat;
  }
}

.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show > .nav-link {
  color: rgb(255 255 255 / 90%) !important;
  font-weight: 600;
  font-family: "Saira";
}

input[type="text"],
input[type="date"],
input[type="password"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 0px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 0px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

input[type="number"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

input[type="email"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 13px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 0px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

span {
  font-family: "Georama-Regular";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.5rem;
  font-family: "QuantumRiseGX";
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

h1 {
  font-size: 36px;
  font-weight: 500 !important;
  font-family: "QuantumRiseGX";
}

h3 {
  font-size: 20px !important;
  font-weight: 800 !important;
  font-family: "QuantumRiseGX" !important;
}

h4 {
  font-size: 15px !important;
  font-weight: 600 !important;
  font-family: "QuantumRiseGX" !important;
}

p {
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: "Georama-Regular" !important;
  /* font-family: "Saira", sans-serif; */
}

.container_fluid {
  max-width: 100%;
}

.container {
  max-width: 90%;
  text-align: left;
}

@media screen and (max-width: 600px) {
  .container {
    max-width: 90%;
    text-align: left;
  }

  .p_all {
    padding: 16px;
  }
}

@media screen and (min-width: 600px) {
  .container {
    max-width: 90%;
    text-align: left;
  }
}

.check {
  box-shadow: inset 0px 0px 0px 1px #db233a;
}

/* .logo{width: 40%; text-align: center;}   */
.center {
  text-align: center;
}

.Ethics-and-governance-portal {
  font-family: Saira;
  font-size: 18px;
  font-weight: 500;
  color: var(--m-main-m-black-1-000000);
}

input[type="text"],
textarea,
select {
  width: 100%;
  padding: 12px 20px !important;
  margin: 0px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 0px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

input[type="number"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 0px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

input[type="email"],
select {
  width: 100%;
  padding: 12px 20px 12px 16px !important;
  margin: 13px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 0px;
  box-sizing: border-box;
  /* box-shadow: 1px 1px 5px #eeecec; */
}

.button {
  border: none;
  width: 100%;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  background-color: #e31837;
}

.button_grey {
  border: none;
  width: 100%;
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  background-color: #f7f6f6;
}

/*   .button1 {background-color: #e31837;}*/
@media screen and (max-width: 600px) {
  .button {
    border: none;
    width: 100%;
    color: white;
    padding: 8px 0px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    background-color: #e31837;
  }

  .button_grey {
    border: none;
    width: 270px;
    color: black;
    padding: 25px 0px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 6px 2px;
    cursor: pointer;
    background-color: #f7f6f6;
  }
}

.rect {
  width: 200px;
  height: 20px;
  background-color: transparent;
}

.logo {
  width: 170px;
}

@media screen and (max-width: 600px) {
  .logo {
    width: 170px;
  }
}

/* .navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show > .nav-link {
  color: #ffffff !important;
  font-weight: 600;
  font-family: "Saira";
  border-bottom: 6px solid #fff;
}

.navbar-light .navbar-nav .nav-link {
  color: #ffffff !important;
  font-weight: 300;
  font-family: "Saira";
} */

.navLink nav-link {
  color: #ffffff !important;
  font-weight: 300 !important;
  font-family: "Saira" !important;
}

.navLink nav-link.active {
  color: #ffffff !important;
  font-weight: 600 !important;
  font-family: "Saira" !important;
  border-bottom: 6px solid #fff !important;
}

.navbar-nav {
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin-bottom: 0;
  list-style: none;
}

@media screen and (max-width: 600px) {
  .navbar-nav {
    display: flex;
    flex-direction: row;
    background-color: #db243a;
    padding: 10px;
    margin-bottom: 0;
    list-style: none;
  }
}

.desk {
  display: block;
}

@media screen and (max-width: 999px) {
  .desk {
    display: none;
  }
}

.mob {
  display: none;
}

@media screen and (max-width: 999px) {
  .mob {
    display: block;
  }
}

b {
  color: #e31837;
  font-size: 12px;
  font-weight: 700;
  font-family: "Georama-Regular";
}

.b_shadow {
  box-shadow: 1px 3px 10px 10px #0000000d;
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.navbar-light .navbar-toggler {
  color: transparent;
  border-color: transparent;
}

.navbar-toggler {
  padding: 0.25rem 0.55rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

/*othe model popup css*/
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 0px !important;
}

.modal-dialog {
  max-width: 800px;
}

@media screen and (max-width: 600px) {
  .modal-dialog {
    max-width: 500px;
    margin-left: 0%;
    margin-top: 15%;
  }
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  background-color: black;
  color: white;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

/*othe model popup css end*/

/* Notification popup*/
.box {
  width: 40%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  padding: 35px;
  border: 2px solid #fff;
  border-radius: 20px/50px;
  background-clip: padding-box;
  text-align: center;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  transition: opacity 500ms;
  visibility: hidden;
  opacity: 0;
}

.overlay:target {
  visibility: visible;
  opacity: 1;
}

.popup {
  margin-left: 62%;
  margin-top: 7%;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  width: 38%;
  position: relative;
  transition: all 5s ease-in-out;
}

.popup h2 {
  margin-top: 0;
  color: #333;
  font-family: Tahoma, Arial, sans-serif;
}

.popup .close {
  position: absolute;
  top: 20px;
  right: 30px;
  transition: all 200ms;
  font-size: 30px;
  font-weight: bold;
  text-decoration: none;
}

.popup .close:hover {
  color: #06d85f;
}

.popup .content {
  max-height: 30%;
  overflow-x: hidden;
}

@media screen and (max-width: 700px) {
  .box {
    width: 70%;
  }

  .popup {
    width: 100%;
    margin-left: 0%;
    margin-top: 15%;
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    position: relative;
    transition: all 5s ease-in-out;
  }
}

/*Notification popup*/
.btn-primary {
  color: #fff;
  background-color: #e31837 !important;
  border-color: #e31837;
}

.rowBg {
  background-color: #ffffff;
  padding: 20px;
  margin-top: 2%;
}

.bottom_line {
  border: 1px solid #eeeeee;
}

.bgwhite {
  background-color: #fff;
}

.p_all {
  padding: 16px;
}

.pl20 {
  padding-left: 20px;
}

.pr20 {
  padding-right: 20px;
}

.pr30 {
  padding-right: 30px;
}

.pt20 {
  padding-top: 20px;
}

.pb20 {
  padding-bottom: 20px;
}

.p10_all {
  padding: 10px;
}

.codeofconduct {
  border: 1px solid #eee;
  padding: 20px;
}

.shadowLRB {
  box-shadow: 2px 15px 10px 0px #0000000d;
}

.row-flex {
  display: flex;
  flex-wrap: wrap;
}

.redFont {
  font-family: Saira;
  font-size: 12px;
  font-weight: 600;
  color: #e31837;
}

.navbar-expand .navbar-nav .nav-link {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.navbar-expand .navbar-nav .nav-link:visited {
  font-weight: 800;
  border-bottom: 6px solid #fff;
}

input[type="text"],
select {
  border-radius: 0px;
  border: solid 1px #e4e4e4;
}

input[type="file"] {
  width: 100%;
  padding-left: 45px;
}

input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
  /* margin-left: 50%; */
  height: 18px;
  overflow-x: hidden;
}

input[placeholder] {
  font-family: saira;
}

input[type="textarea"] {
  margin: 0;
  width: 100%;
  height: max-content;
}

.infinite-scroll-component {
  overflow-x: hidden !important;
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
  box-shadow: 0 0 0 0.25rem transparent !important;
}

.modal-footer {
  border-top: 1px solid transparent !important;
}

.form-check-input:checked {
  background-color: #e31837 !important;
  border-color: #e31837 !important;
}

.form-check-input:focus {
  border-color: none !important;
  outline: 0;
  box-shadow: none !important;
}

.form-control {
  font-family: system-ui, sans-serif;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.1;
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
}

.form-control + .form-control {
  margin-top: 1em;
}

.form-control:focus-within {
  color: var(#e31837);
}

input[type="checkbox"] {
  cursor: pointer;
}
input[type="radio"] {
  /* Add if not using autoprefixer */
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--form-background);
  /* Not removed via appearance */
  /* margin: 0; */
  font: inherit;
  color: #e31837;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid #e31837;
  border-radius: 50%;
  transform: translateY(-0.075em);
  margin-right: 12px;
  display: inline-grid;
  place-content: center;
  cursor: pointer;
}

input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: #e31837;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

.textstyle[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

.accordion-button:focus {
  z-index: 3;
  border-color: #86b7fe00;
  outline: 0;
  box-shadow: 0 0 0 0.25rem transparent !important;
}

.invalid-feedback {
  display: block !important;
}

.table > :not(:first-child) {
  border-top: 0px solid currentColor !important;
}

#name:checked ~ .name {
  display: block;
}

#name:checked ~ .rollno {
  display: none;
}

#rollno:checked ~ .rollno {
  display: block;
}

#rollno:checked ~ .name {
  display: none;
}

.lightbox {
  display: none;
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;

  top: 50px;
  left: 30%;
  background: transparent;
  padding: 40px;
}

.lightbox:target {
  outline: none;
  width: 100%;
  display: block;
}

/* Multiselect CSS start */
.highlightOption {
  background: #db243a !important;
  color: #fff;
}

.multiSelectContainer li:hover {
  background: #db243a !important;
  color: #fff;
  cursor: pointer;
}

.chip {
  padding: 4px 10px;
  background: #db243a !important;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  line-height: 19px;
  color: #fff;
}

.searchWrapper {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0px !important;
  min-height: 22px;
  position: relative;
}

/* multiselect End */

/* .navbar-light .navbar-nav .nav-link:enabled {font-weight: 800;
    border-bottom: 5px solid #fff;
    margin-bottom: -22px;} */
.file {
  position: relative;
  overflow: hidden;
}

.fileUpload {
  position: absolute;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}

.a {
  color: #db233a;
}

a {
  color: #0d6efd;
  text-decoration: none !important;
}

a:hover {
  color: transparent;
}

.card-media {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  height: 12em;
  overflow: hidden;
}

.McCardImage {
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  background-position: 50%;
  height: 12em;
}

.cardheight {
  height: 250px;
}

.bigTable {
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
  height: 400px;
}

input[type="textarea"] {
  margin: 0px;
  width: 100%;
  height: 120px;
  padding: 10px;
}

.form-select:focus,
.form-select:focus-visible {
  border-color: #eeeeee !important;
  outline: 0;
  box-shadow: 0 0 0 0.25rem transparent !important;
}

.text-left {
  text-align: left;
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.3;
  background: #6d6e71;
}

.removebtn {
  margin-left: 10px;
}

.picky__dropdown .option.selected,
.picky__dropdown li.selected {
  background-color: #ffeeee !important;
  color: #000 !important;
  font-weight: bold !important;
}

.picky__dropdown .option input[type="checkbox"]:checked {
  background-color: #e31837 !important;
  border-color: #e31837 !important;
}

.picky__input {
  height: 54px !important;
  border-radius: 0px !important;
}

.list-group {
  height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: #e31837;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;;;;;;;GAOG;AACH;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yDAA+C;EAC/C,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yDAA+C;IAC/C,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yDAA+C;IAC/C,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;;AAEA;;;;EAIE,wCAAwC;EACxC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,uCAAuC;EACvC,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IAEE,aAAa;IAEb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yDAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EAEE,aAAa;EAEb,uBAAuB;EAEvB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,2BAA2B;;AAE3B,sBAAsB;AACtB;EACE,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;EAChC;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;EAElC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,mDAAmD;EACnD,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;;4BAE4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,gCAAgC;EAChC,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Saira:wght@100;200;300;400;500;600&display=swap\");\n@import url(\"https://fontsstorage.blob.core.windows.net/html/css/quantum.css\");\n@import url(\"https://fontsstorage.blob.core.windows.net/html/css/georama.css\");\n\n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n} */\nbody {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  width: 100%;\n  background-image: url(assets/images/bg2023.png);\n  background-color: #eee;\n  overflow-y: scroll;\n  font-family: \"Georama-Regular\" !important;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover !important;\n}\n\n@media screen and (max-width: 600px) {\n  body {\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    width: 100%;\n    background-image: url(assets/images/bg2023.png);\n    background-size: contain;\n    background-color: #eee;\n    background-repeat: no-repeat;\n  }\n}\n\n@media screen and (min-width: 600px) {\n  body {\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    width: 100%;\n    background-image: url(assets/images/bg2023.png);\n    background-size: contain;\n    background-color: #eee;\n    background-repeat: no-repeat;\n  }\n}\n\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .show > .nav-link {\n  color: rgb(255 255 255 / 90%) !important;\n  font-weight: 600;\n  font-family: \"Saira\";\n}\n\ninput[type=\"text\"],\ninput[type=\"date\"],\ninput[type=\"password\"],\nselect {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 0px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 0px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\ninput[type=\"number\"],\nselect {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 8px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\ninput[type=\"email\"],\nselect {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 13px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 0px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\nspan {\n  font-family: \"Georama-Regular\";\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 0.5rem;\n  font-family: \"QuantumRiseGX\";\n  font-weight: 500;\n  line-height: 1.2;\n  color: inherit;\n}\n\nh1 {\n  font-size: 36px;\n  font-weight: 500 !important;\n  font-family: \"QuantumRiseGX\";\n}\n\nh3 {\n  font-size: 20px !important;\n  font-weight: 800 !important;\n  font-family: \"QuantumRiseGX\" !important;\n}\n\nh4 {\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  font-family: \"QuantumRiseGX\" !important;\n}\n\np {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  font-family: \"Georama-Regular\" !important;\n  /* font-family: \"Saira\", sans-serif; */\n}\n\n.container_fluid {\n  max-width: 100%;\n}\n\n.container {\n  max-width: 90%;\n  text-align: left;\n}\n\n@media screen and (max-width: 600px) {\n  .container {\n    max-width: 90%;\n    text-align: left;\n  }\n\n  .p_all {\n    padding: 16px;\n  }\n}\n\n@media screen and (min-width: 600px) {\n  .container {\n    max-width: 90%;\n    text-align: left;\n  }\n}\n\n.check {\n  box-shadow: inset 0px 0px 0px 1px #db233a;\n}\n\n/* .logo{width: 40%; text-align: center;}   */\n.center {\n  text-align: center;\n}\n\n.Ethics-and-governance-portal {\n  font-family: Saira;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--m-main-m-black-1-000000);\n}\n\ninput[type=\"text\"],\ntextarea,\nselect {\n  width: 100%;\n  padding: 12px 20px !important;\n  margin: 0px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 0px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\ninput[type=\"number\"],\nselect {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 8px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 0px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\ninput[type=\"email\"],\nselect {\n  width: 100%;\n  padding: 12px 20px 12px 16px !important;\n  margin: 13px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 0px;\n  box-sizing: border-box;\n  /* box-shadow: 1px 1px 5px #eeecec; */\n}\n\n.button {\n  border: none;\n  width: 100%;\n  color: white;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 4px 2px;\n  cursor: pointer;\n  background-color: #e31837;\n}\n\n.button_grey {\n  border: none;\n  width: 100%;\n  color: black;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 4px 2px;\n  cursor: pointer;\n  background-color: #f7f6f6;\n}\n\n/*   .button1 {background-color: #e31837;}*/\n@media screen and (max-width: 600px) {\n  .button {\n    border: none;\n    width: 100%;\n    color: white;\n    padding: 8px 0px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 12px;\n    background-color: #e31837;\n  }\n\n  .button_grey {\n    border: none;\n    width: 270px;\n    color: black;\n    padding: 25px 0px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 6px 2px;\n    cursor: pointer;\n    background-color: #f7f6f6;\n  }\n}\n\n.rect {\n  width: 200px;\n  height: 20px;\n  background-color: transparent;\n}\n\n.logo {\n  width: 170px;\n}\n\n@media screen and (max-width: 600px) {\n  .logo {\n    width: 170px;\n  }\n}\n\n/* .navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .show > .nav-link {\n  color: #ffffff !important;\n  font-weight: 600;\n  font-family: \"Saira\";\n  border-bottom: 6px solid #fff;\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: #ffffff !important;\n  font-weight: 300;\n  font-family: \"Saira\";\n} */\n\n.navLink nav-link {\n  color: #ffffff !important;\n  font-weight: 300 !important;\n  font-family: \"Saira\" !important;\n}\n\n.navLink nav-link.active {\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  font-family: \"Saira\" !important;\n  border-bottom: 6px solid #fff !important;\n}\n\n.navbar-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: row;\n  padding: 10px;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n@media screen and (max-width: 600px) {\n  .navbar-nav {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: row;\n    background-color: #db243a;\n    padding: 10px;\n    margin-bottom: 0;\n    list-style: none;\n  }\n}\n\n.desk {\n  display: block;\n}\n\n@media screen and (max-width: 999px) {\n  .desk {\n    display: none;\n  }\n}\n\n.mob {\n  display: none;\n}\n\n@media screen and (max-width: 999px) {\n  .mob {\n    display: block;\n  }\n}\n\nb {\n  color: #e31837;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: \"Georama-Regular\";\n}\n\n.b_shadow {\n  box-shadow: 1px 3px 10px 10px #0000000d;\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(assets/images/menu2.png);\n}\n\n.navbar-light .navbar-toggler {\n  color: transparent;\n  border-color: transparent;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.55rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n/*othe model popup css*/\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-right: 0px !important;\n}\n\n.modal-dialog {\n  max-width: 800px;\n}\n\n@media screen and (max-width: 600px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin-left: 0%;\n    margin-top: 15%;\n  }\n}\n\n.modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  background-color: black;\n  color: white;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n/*othe model popup css end*/\n\n/* Notification popup*/\n.box {\n  width: 40%;\n  margin: 0 auto;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 35px;\n  border: 2px solid #fff;\n  border-radius: 20px/50px;\n  background-clip: padding-box;\n  text-align: center;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: transparent;\n  transition: opacity 500ms;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.overlay:target {\n  visibility: visible;\n  opacity: 1;\n}\n\n.popup {\n  margin-left: 62%;\n  margin-top: 7%;\n  padding: 20px;\n  background: #fff;\n  border-radius: 5px;\n  width: 38%;\n  position: relative;\n  transition: all 5s ease-in-out;\n}\n\n.popup h2 {\n  margin-top: 0;\n  color: #333;\n  font-family: Tahoma, Arial, sans-serif;\n}\n\n.popup .close {\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  transition: all 200ms;\n  font-size: 30px;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.popup .close:hover {\n  color: #06d85f;\n}\n\n.popup .content {\n  max-height: 30%;\n  overflow-x: hidden;\n}\n\n@media screen and (max-width: 700px) {\n  .box {\n    width: 70%;\n  }\n\n  .popup {\n    width: 100%;\n    margin-left: 0%;\n    margin-top: 15%;\n    padding: 20px;\n    background: #fff;\n    border-radius: 5px;\n    position: relative;\n    transition: all 5s ease-in-out;\n  }\n}\n\n/*Notification popup*/\n.btn-primary {\n  color: #fff;\n  background-color: #e31837 !important;\n  border-color: #e31837;\n}\n\n.rowBg {\n  background-color: #ffffff;\n  padding: 20px;\n  margin-top: 2%;\n}\n\n.bottom_line {\n  border: 1px solid #eeeeee;\n}\n\n.bgwhite {\n  background-color: #fff;\n}\n\n.p_all {\n  padding: 16px;\n}\n\n.pl20 {\n  padding-left: 20px;\n}\n\n.pr20 {\n  padding-right: 20px;\n}\n\n.pr30 {\n  padding-right: 30px;\n}\n\n.pt20 {\n  padding-top: 20px;\n}\n\n.pb20 {\n  padding-bottom: 20px;\n}\n\n.p10_all {\n  padding: 10px;\n}\n\n.codeofconduct {\n  border: 1px solid #eee;\n  padding: 20px;\n}\n\n.shadowLRB {\n  box-shadow: 2px 15px 10px 0px #0000000d;\n}\n\n.row-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.redFont {\n  font-family: Saira;\n  font-size: 12px;\n  font-weight: 600;\n  color: #e31837;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.navbar-expand .navbar-nav .nav-link:visited {\n  font-weight: 800;\n  border-bottom: 6px solid #fff;\n}\n\ninput[type=\"text\"],\nselect {\n  border-radius: 0px;\n  border: solid 1px #e4e4e4;\n}\n\ninput[type=\"file\"] {\n  width: 100%;\n  padding-left: 45px;\n}\n\ninput[type=\"file\"]::-webkit-file-upload-button {\n  visibility: hidden;\n  /* margin-left: 50%; */\n  height: 18px;\n  overflow-x: hidden;\n}\n\ninput[placeholder] {\n  font-family: saira;\n}\n\ninput[type=\"textarea\"] {\n  margin: 0;\n  width: 100%;\n  height: max-content;\n}\n\n.infinite-scroll-component {\n  overflow-x: hidden !important;\n}\n\n.btn-check:focus + .btn-primary,\n.btn-primary:focus {\n  box-shadow: 0 0 0 0.25rem transparent !important;\n}\n\n.modal-footer {\n  border-top: 1px solid transparent !important;\n}\n\n.form-check-input:checked {\n  background-color: #e31837 !important;\n  border-color: #e31837 !important;\n}\n\n.form-check-input:focus {\n  border-color: none !important;\n  outline: 0;\n  box-shadow: none !important;\n}\n\n.form-control {\n  font-family: system-ui, sans-serif;\n  font-size: 2rem;\n  font-weight: bold;\n  line-height: 1.1;\n  display: grid;\n  grid-template-columns: 1em auto;\n  gap: 0.5em;\n}\n\n.form-control + .form-control {\n  margin-top: 1em;\n}\n\n.form-control:focus-within {\n  color: var(#e31837);\n}\n\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n}\ninput[type=\"radio\"] {\n  /* Add if not using autoprefixer */\n  -webkit-appearance: none;\n  /* Remove most all native input styles */\n  appearance: none;\n  /* For iOS < 15 */\n  background-color: var(--form-background);\n  /* Not removed via appearance */\n  /* margin: 0; */\n  font: inherit;\n  color: #e31837;\n  width: 1.15em;\n  height: 1.15em;\n  border: 0.15em solid #e31837;\n  border-radius: 50%;\n  transform: translateY(-0.075em);\n  margin-right: 12px;\n  display: inline-grid;\n  place-content: center;\n  cursor: pointer;\n}\n\ninput[type=\"radio\"]::before {\n  content: \"\";\n  width: 0.65em;\n  height: 0.65em;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 120ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--form-control-color);\n  /* Windows High Contrast Mode */\n  background-color: #e31837;\n}\n\ninput[type=\"radio\"]:checked::before {\n  transform: scale(1);\n}\n\n.textstyle[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\n.accordion-button:focus {\n  z-index: 3;\n  border-color: #86b7fe00;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem transparent !important;\n}\n\n.invalid-feedback {\n  display: block !important;\n}\n\n.table > :not(:first-child) {\n  border-top: 0px solid currentColor !important;\n}\n\n#name:checked ~ .name {\n  display: block;\n}\n\n#name:checked ~ .rollno {\n  display: none;\n}\n\n#rollno:checked ~ .rollno {\n  display: block;\n}\n\n#rollno:checked ~ .name {\n  display: none;\n}\n\n.lightbox {\n  display: none;\n  position: fixed;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n\n  top: 50px;\n  left: 30%;\n  background: transparent;\n  padding: 40px;\n}\n\n.lightbox:target {\n  outline: none;\n  width: 100%;\n  display: block;\n}\n\n/* Multiselect CSS start */\n.highlightOption {\n  background: #db243a !important;\n  color: #fff;\n}\n\n.multiSelectContainer li:hover {\n  background: #db243a !important;\n  color: #fff;\n  cursor: pointer;\n}\n\n.chip {\n  padding: 4px 10px;\n  background: #db243a !important;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  border-radius: 11px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  line-height: 19px;\n  color: #fff;\n}\n\n.searchWrapper {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 0px !important;\n  min-height: 22px;\n  position: relative;\n}\n\n/* multiselect End */\n\n/* .navbar-light .navbar-nav .nav-link:enabled {font-weight: 800;\n    border-bottom: 5px solid #fff;\n    margin-bottom: -22px;} */\n.file {\n  position: relative;\n  overflow: hidden;\n}\n\n.fileUpload {\n  position: absolute;\n  font-size: 50px;\n  opacity: 0;\n  right: 0;\n  top: 0;\n}\n\n.a {\n  color: #db233a;\n}\n\na {\n  color: #0d6efd;\n  text-decoration: none !important;\n}\n\na:hover {\n  color: transparent;\n}\n\n.card-media {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000;\n  height: 12em;\n  overflow: hidden;\n}\n\n.McCardImage {\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 100%;\n  background-position: 50%;\n  height: 12em;\n}\n\n.cardheight {\n  height: 250px;\n}\n\n.bigTable {\n  overflow-x: hidden !important;\n  -webkit-overflow-scrolling: touch;\n  height: 400px;\n}\n\ninput[type=\"textarea\"] {\n  margin: 0px;\n  width: 100%;\n  height: 120px;\n  padding: 10px;\n}\n\n.form-select:focus,\n.form-select:focus-visible {\n  border-color: #eeeeee !important;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem transparent !important;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.3;\n  background: #6d6e71;\n}\n\n.removebtn {\n  margin-left: 10px;\n}\n\n.picky__dropdown .option.selected,\n.picky__dropdown li.selected {\n  background-color: #ffeeee !important;\n  color: #000 !important;\n  font-weight: bold !important;\n}\n\n.picky__dropdown .option input[type=\"checkbox\"]:checked {\n  background-color: #e31837 !important;\n  border-color: #e31837 !important;\n}\n\n.picky__input {\n  height: 54px !important;\n  border-radius: 0px !important;\n}\n\n.list-group {\n  height: 350px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.list-group-item {\n  cursor: pointer;\n}\n\n.list-group-item:hover {\n  background-color: #e31837;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
